import React from 'react';

function Docs() {
    return (
        <div>
            <h2>Documentación</h2>
            <p>Manual de usuario del sistema.</p>

            <div style={{ height: 'calc(100vh - 220px)' }}>
                <iframe
                    src="/Manual_Usuario.pdf"
                    title="Manual de usuario"
                    style={{ width: '100%', height: '100%', border: 'none' }}
                />
            </div>

            <p className="mt-3">
                Si no se ve el manual, puedes descargarlo haciendo clic{' '}
                <a href="/Manual_Usuario.pdf" target="_blank" rel="noreferrer">
                    aquí
                </a>.
            </p>
        </div>
    );
}

export default Docs;